(function() {
	
	function Loader()
	{
		this.View_constructor();
		this.init();
	}

	var p = createjs.extend(Loader, cm.View);

	p.init = function() {
		this._targetProgress = 0;
		this._progress = 0;

		this.loaderBarContainer = new cjs.Container();

		this.loaderBar = new cjs.Shape();
		this.loaderBar.graphics.f('#ffdf00').dr(0, -5.5, 177, 11);
		this.loaderBar.set({scaleX: 0, x: -89});

		this.loaderBarFrame = new cjs.Sprite(cm.Assets.lib.PreloadSS, 'loader_bar_frame');
		this.loaderBarFrame.regs('center');

		this.loaderBarContainer.addChild(
			this.loaderBar,
			this.loaderBarFrame
		);


		

		this.addChild(
			// this.bg.set({ox: 0.5, oy: 0.5}),
			this.loaderBarContainer.set({ox: 0.5, oy: 0.5, ry: 100})
		);

		this.visible = false;
	};

	p.update = function() {

		var p;
		if (this.visible === true) {

			p = cm.Assets.getCurrentProgress();

			if (p) {
				if (p > this._targetProgress) {
					this._targetProgress = p;
				}

				this._progress = Math.lerp(this._progress, this._targetProgress, 0.1);
				this.loaderBar.scaleX = this._progress;
			} else if (this._finishingLoad) {
				this.loaderBar.scaleX = this._progress;
			}
		}
	};

	p.animateIn = function(wait) {
		this.visible = true;
	};

	p.animateOut = function(wait, maxDur) {
		var dur = Math.floor((maxDur || 700) * (1 - this._progress));
		var t = cjs.Tween.get(this)
			.to({_progress: 1}, dur);

		this._finishingLoad = true;

		return cjs.Tween.get(this)
			.wait(t.duration + 200)
			.set({visible: false})
			.call(this._resetLoadProgress, null, this);
	};
	
	p._resetLoadProgress = function() {
		this._progress = 0;
		this._targetProgress = 0;
		this._finishingLoad = false;
		this.loaderBar.scaleX = 0;
	};

	cm.View.Loader = cjs.promote(Loader, "View");

})();